module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-42.bc0ad24a.svg";